if ( typeof debounce !== 'function' ) {
  window.debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
window.KEYCODES = {
  TAB: 9,
  ESC: 27,
  DOWN: 40,
  RIGHT: 39,
  UP: 38,
  LEFT: 37,
  RETURN: 13
};
window.KT_PREFIX = 'kt-';

window.KROWN = window.KROWN || {};
window.KROWN.previouslyFocused = null;
window.KROWN.functions = (() => {

  /* ---------------- IMAGE HELPERS ---------------- */

  const setImagesize = (img) => {
    let size = 0;
    if (img.offsetWidth / img.dataset.ratio < img.offsetHeight) {
      size = Math.ceil(img.offsetHeight * parseFloat(img.dataset.ratio));
    } else {
      size = Math.ceil(img.offsetWidth);
    }
    if ( size > 0 ) {
      img.setAttribute('sizes', `${size}px`);
    }
  };

  const resizeObserver = ('ResizeObserver' in window)
    ? new ResizeObserver(entries => {
        for (const entry of entries) setImagesize(entry.target);
      })
    : null;
    
  const handleImageLoad = img => {
    setImagesize(img);
    resizeObserver.observe(img);
  };

  /* ---------------- SCROLL PROGRESS CORE ---------------- */

  const progressElements = new Set();

  let ticking = false;
  let needsHeightSync = false;

  const updateScrollProgress = () => {
    
    if (needsHeightSync) {
      parallaxHeightPairs.forEach(({ target, ref }) => {
        target.style.height = `${ref.offsetHeight}px`;
      });
      needsHeightSync = false;
    }

    const viewportHeight = window.innerHeight;
  
    progressElements.forEach(({ el, callback, mode }) => {
      const rect = el.getBoundingClientRect();
      let progress = 0;
  
      if ( mode === 'enter' ) {
        // 0% when section top is at viewport bottom
        // 100% when section top is at viewport top
        // exception when the section is at the bottom of the page
        const vh = innerHeight;
        const max = document.documentElement.scrollHeight - vh;
        const top = rect.top + scrollY;
        const start = top - vh;
        progress = ((scrollY - start) * 100) / (Math.min(top, max) - start);
      } else if ( mode === 'cover' ) {
        // 0% when section is fully visible at top
        // 100% when section has fully scrolled past (bottom <= 0)
        const start = 0;
        const end = -(rect.height - viewportHeight);
        const scrolled = Math.min(Math.max(rect.top, end), start);
        progress = ((start - scrolled) * 100) / (start - end);
      } else {
        // default: 0% when section enters viewport,
        // 100% when fully scrolled through
        progress = ((viewportHeight - rect.top) * 100) / (rect.height + viewportHeight);
      }
  
      progress = Math.min(Math.max(progress, 0), 100);
      callback(progress, el);
    });
  
    ticking = false;
  };
  
  const onScrollOrResize = (e) => {
    if (e.type === 'resize') needsHeightSync = true;
    if (!ticking) {
      requestAnimationFrame(updateScrollProgress);
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize, { passive: true });

  const observeScrollProgress = (el, callback, mode = 'full') => {
    const item = { el, callback, mode };
    progressElements.add(item);
    requestAnimationFrame(updateScrollProgress);
    return () => progressElements.delete(item);
  };

  /* ---------------- PARALLAX HANDLER ---------------- */

  const parallaxHeightPairs = [];
  
  const handleParallax = id => {
    const container = document.getElementById(id);
    if (!container) return;
  
    const start = parseFloat(container.dataset.jsParallaxStart) || 0;
    const end = parseFloat(container.dataset.jsParallaxEnd) || 0;
    const unit = container.dataset.jsParallaxUnit || 'px';
    const property = container.dataset.jsParallaxProperty || 'transform'; 
    const mode = container.dataset.jsParallaxMode || 'full';
    const targets = container.querySelectorAll('[data-js-parallax]');

    let scrollRef = container;

    targets.forEach(t => {
      const ref = t.closest('[data-js-parallax-height-reference]')
        || container.querySelector('[data-js-parallax-height-reference]');
      if (ref) {
        t.style.height = `${ref.offsetHeight}px`;
        parallaxHeightPairs.push({ target: t, ref });
        if (ref.hasAttribute('data-js-parallax-scroll-reference')) {
          scrollRef = ref;
        }
      }
    });
  
    observeScrollProgress(scrollRef, (progress) => {
      const value = start + (end - start) * (progress / 100);
  
      targets.forEach(t => {
        if (property === 'transform') {
          t.style.transform = `translateY(${value}${unit})`;
        } else if (property === 'backgroundSize') {
          t.style.backgroundSize = `${value}${unit} 100%`;
        } else {
          t.style[property] = `${value}${unit}`;
        }
      });
    }, mode);
  };

  /* ---------------- EVENT LISTENERS ---------------- */

  const eventDispatcher = (eventType, detail) => {
    document.dispatchEvent(new CustomEvent(eventType, {
      bubbles: true,
      detail: detail
    }));
  };

  const updateCart = (openDrawer = true) => {
    window.refreshCart(openDrawer);
  };
  const closeCartDrawer = () => {
    document.querySelector('[data-js-site-cart-sidebar]').hide();
  };
  const openCartDrawer = () => {
    document.querySelector('[data-js-site-cart-sidebar]').show();
  };
  
  return { handleImageLoad, setImagesize, resizeObserver, observeScrollProgress, handleParallax, eventDispatcher, updateCart, closeCartDrawer, openCartDrawer };

})();

document.addEventListener('krown:cart:error', (e) => {
  if ( document.body.classList.contains('template-cart') ) {
    window.scrollTo({
      top: document.querySelector('#AjaxCartForm .kt-alert') ? Math.max(0, document.querySelector('#AjaxCartForm .kt-alert').offsetTop - 100) : 0,
      behavior: 'smooth'
    });
  } else {
    document.querySelector('#site-cart-sidebar .kt-sidebar__content')?.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const layoutButtons = document.querySelectorAll('.collection__layout-button');
  const grid = document.getElementById('main-collection-product-grid');

  if (!layoutButtons.length || !grid) return;

  function animateLayoutChange(newLayoutMode) {
    const items = [...grid.children];

    // FIRST
    const firstRects = items.map(item => item.getBoundingClientRect());

    // Change layout
    grid.setAttribute('data-grid-layout', newLayoutMode);

    requestAnimationFrame(() => {
      // LAST
      const lastRects = items.map(item => item.getBoundingClientRect());

      items.forEach((item, index) => {
        const dx = firstRects[index].left - lastRects[index].left;
        const dy = firstRects[index].top - lastRects[index].top;

        // INVERT
        item.style.transition = 'none';
        item.style.transform = `translate(${dx}px, ${dy}px)`;

        // PLAY
        requestAnimationFrame(() => {
          item.style.transition = 'transform 400ms ease';
          item.style.transform = '';
        });
      });
    });
  }

  layoutButtons.forEach(button => {
    button.addEventListener('click', function() {
      const newLayoutMode = this.getAttribute('data-layout-mode');

      if (grid.getAttribute('data-grid-layout') === newLayoutMode) {
        return;
      }

      // Save preference
      fetch('/cart/update.js', {
        body: JSON.stringify({
          attributes: {
            collection_layout: newLayoutMode
          }
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      // Animate layout switch
      animateLayoutChange(newLayoutMode);

      layoutButtons.forEach(btn => btn.classList.remove('is-selected'));
      this.classList.add('is-selected');
    });
  });
});


/* Product swatches */
function attachSwatchListeners() {
  const container = document.querySelector('.custom-swatches-container');
  if (!container) return;
  container.removeEventListener('click', swatchClickHandler);
  container.addEventListener('click', swatchClickHandler);
}

function swatchClickHandler(e) {
  const swatch = e.target.closest('.custom-swatch');
  if (!swatch) return;

  e.preventDefault();

  const productHandle = swatch.dataset.handle;
  const sectionId = swatch.dataset.sectionId;

  const newUrl = `/products/${productHandle}`;
  window.history.replaceState({ path: newUrl }, '', newUrl);

  const url = `/products/${productHandle}?section_id=${sectionId}`;

  fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch section content');
      }
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');

      // Elements to update
      const elementsToUpdate = [
        'product-page'
      ];

      elementsToUpdate.forEach(selector => {
        const newElement = newDoc.querySelector(selector);
        const currentElement = document.querySelector(selector);
        if (newElement && currentElement) {
          currentElement.replaceWith(newElement);
        }
      });

      // Update swatch active state
    /*  swatch.closest('.image-swatches-container').querySelectorAll('.swatch-button').forEach(el => {
        el.classList.remove('current-color');
      })
      swatch.classList.add('current-color');*/

      // Reinitialize  third-party scripts below (TBD)
      attachSwatchListeners();
      
    })
    .catch(error => {
      console.error('Error updating product section:', error);
    });
}
document.addEventListener('DOMContentLoaded', () => {
  attachSwatchListeners();
});

/* Product grid slider */
function productGridSlider() {
  document.querySelectorAll('.kt-product-image-slider').forEach((slider, sliderIndex) => {
    const slides = [...slider.querySelectorAll('.kt-product-image__container')];

    if (slides.length <= 1) {
      slider.classList.add('is-single-image');
      return;
    }

    // Create track
    const track = document.createElement('div');
    track.className = 'slider-track';

    slides.forEach(slide => {
      track.appendChild(slide);
    });

    const progress = slider.querySelector('.slider-progress');
    const prevBtn = slider.querySelector('.slider-arrow--prev');
    const nextBtn = slider.querySelector('.slider-arrow--next');

    slider.insertBefore(track, progress);
    slider.classList.add('is-ready');
    let current = 0;
    let startX = 0;
    let pointerDown = false;
    const progressActive = slider.querySelector('.slider-progress__active');

    function update() {
      track.style.transform = `translateX(-${current * 100}%)`;
      prevBtn.hidden = current === 0;
      nextBtn.hidden = current === slides.length - 1;
      const width = 100 / slides.length;
      progressActive.style.width = `${width}%`;
      progressActive.style.transform = `translateX(${current * 100}%)`;
    }

    function goTo(index) {
      current = Math.max(
        0,
        Math.min(index, slides.length - 1)
      );
      update();
    }

    prevBtn.addEventListener('click', e => {
      e.preventDefault();
      goTo(current - 1);
    });

    nextBtn.addEventListener('click', e => {
      e.preventDefault();
      goTo(current + 1);
    });

    /* Swipe / drag support */

    const swipeArea = slider.closest('.kt-product-image ').querySelector('.kt-product-image__link');

    swipeArea.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    swipeArea.addEventListener('touchend', e => {
      const diffX = e.changedTouches[0].clientX - startX;
      const diffY = e.changedTouches[0].clientY - startY;

      // Ignore vertical scrolling
      if (Math.abs(diffY) > Math.abs(diffX)) return;

      if (Math.abs(diffX) < 40) return;

      e.preventDefault();

      if (diffX < 0) {
        goTo(current + 1);
      } else {
        goTo(current - 1);
      }
    });

    track.addEventListener('pointercancel', () => {
      pointerDown = false;
    });
    update();

    /* First product peek animation */
    if (sliderIndex === 0) {
      const observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        setTimeout(() => {
          track.style.transition = 'transform .6s ease';
          track.style.transform = 'translateX(-30%)';
          const width = 100 / slides.length;
          progressActive.style.width = `${width}%`;
          progressActive.style.transform = 'translateX(30%)';
          setTimeout(() => {
            track.style.transform = 'translateX(0)';
            progressActive.style.transform = 'translateX(0)';
            setTimeout(() => {
              update();
            }, 600);
          }, 1000);
        }, 500);
      }, {
        threshold: 0.5
      });
      observer.observe(slider);
    }

  });
}
document.addEventListener('DOMContentLoaded', () => {
  productGridSlider();
});

document.addEventListener('krown:main-collection-grid:filtered', (event) => {
  productGridSlider();
});
document.addEventListener('product-recommendations-loaded', (event) => {
  productGridSlider();
});

/* Wishlits notice */
function showWishlistNotice(message, options = {}) {

  const {
    type = 'success',
    showWishlistButton = false
  } = options;

  let container = document.querySelector('.wishlist-notice-container');

  if (!container) {
    container = document.createElement('div');
    container.className = 'wishlist-notice-container';
    document.body.appendChild(container);
  }

  const notice = document.createElement('div');
  notice.className = `wishlist-notice wishlist-notice--${type}`;

  notice.innerHTML = `
    <div class="wishlist-notice__content">
      <div class="wishlist-notice__text">
        <span>${message}</span>

        ${showWishlistButton ? `
          <a
            href="/pages/wishlist"
            class="wishlist-notice__action kt-text-animation--underline"
          >
            View Wishlist
          </a>
        ` : ''}
      </div>

      <button
        class="wishlist-notice__close"
        aria-label="Close notification"
      >
        &times;
      </button>
    </div>
  `;

  container.appendChild(notice);

  requestAnimationFrame(() => {
    notice.classList.add('is-visible');
  });

  let timeout = setTimeout(removenotice, 3000);

  function removenotice() {
    notice.classList.remove('is-visible');

    notice.addEventListener('transitionend', () => {
      notice.remove();

      if (!container.children.length) {
        container.remove();
      }
    }, { once: true });
  }

  notice.querySelector('.wishlist-notice__close')
    .addEventListener('click', removenotice);

  notice.addEventListener('mouseenter', () => {
    clearTimeout(timeout);
  });

  notice.addEventListener('mouseleave', () => {
    timeout = setTimeout(removenotice, 2000);
  });
}

document.addEventListener('ooo-wishlist:product-added', (event) => {
  const productTitle =
    event.detail?.product?.title ||
    event.detail?.title ||
    'Product';

  showWishlistNotice(
    `${productTitle} added to wishlist`,
    {
      showWishlistButton: true
    }
  );
});

document.addEventListener('ooo-wishlist:product-removed', (event) => {
  const productTitle =
    event.detail?.product?.title ||
    event.detail?.title ||
    'Product';

  showWishlistNotice(
    `${productTitle} removed from wishlist`
  );
});